<div class="mx-auto max-w-screen-2xl py-32 md:py-14 lg:px-32">
  <!-- Header with Title -->
  <div class="mb-12">
    <span class="mat-display-2 mb-0 font-bold text-dark-green">Copy management</span>
  </div>

  <!-- Search and Namespace Row -->
  <div class="mb-6 flex flex-col items-center justify-between gap-4 md:flex-row">
    <div class="w-full md:w-[350px]">
      <!-- Search Field (Left) -->
      <app-custom-search-field
        [(ngModel)]="searchTerm"
        (ngModelChange)="applyFilter()"
        [placeholder]="'Keresés'"
        [ariaLabel]="'Keresés'"
        maxWidth="100%"
      ></app-custom-search-field>
    </div>

    <!-- Namespace Dropdown (Right) -->
    <app-common-single-selector
      [options]="namespaceOptions"
      [label]="'Rent a Car lépések'"
      [(ngModel)]="selectedNamespaceId"
      (ngModelChange)="onNamespaceChange()"
      class="w-[calc(100%-32px)] md:w-[350px]"
    ></app-common-single-selector>
  </div>

  <!-- Table Card -->
  <mat-card class="mat-elevation-z0 rounded-2xl md:p-14">
    <div>
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z0 w-full"
      >
        <!-- Copy Key Column -->
        <ng-container matColumnDef="copyKey">
          <th mat-header-cell *matHeaderCellDef>Copy kulcs</th>
          <td mat-cell *matCellDef="let element">
            <span
              class="inline-block max-w-[200px] truncate pr-2 font-mono text-sm sm:max-w-[150px] md:max-w-[150px] lg:max-w-[160px] xl:max-w-[285px]"
              [matTooltip]="element.copyKey"
              matTooltipPosition="above"
            >
              {{ element.copyKey }}
            </span>
          </td>
        </ng-container>

        <!-- Hungarian Column -->
        <ng-container matColumnDef="hungarian">
          <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
            <span class="mr-1">{{ FLAG_HU }}</span> Magyar
          </th>
          <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
            <span
              class="inline-block max-w-[200px] truncate pr-2 sm:max-w-[150px] md:max-w-[150px] lg:max-w-[160px] xl:max-w-[285px]"
              [matTooltip]="element.placeHolderInHungarian"
              matTooltipPosition="above"
            >
              {{ element.placeHolderInHungarian }}
            </span>
          </td>
        </ng-container>

        <!-- English Column -->
        <ng-container matColumnDef="english">
          <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
            <span class="mr-1">{{ FLAG_GB }}</span> English
          </th>
          <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
            <span
              class="inline-block max-w-[200px] truncate pr-2 sm:max-w-[150px] md:max-w-[150px] lg:max-w-[160px] xl:max-w-[285px]"
              [matTooltip]="element.placeHolderInEnglish"
              matTooltipPosition="above"
            >
              {{ element.placeHolderInEnglish }}
            </span>
          </td>
        </ng-container>

        <!-- Last Modified Column -->
        <ng-container matColumnDef="lastModified">
          <th mat-header-cell *matHeaderCellDef class="w-40">
            Módosítva
          </th>
          <td mat-cell *matCellDef="let element" class="w-40">
            {{ formatDate(element.lastModified) }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-16 md:w-44"></th>
          <td mat-cell *matCellDef="let element" class="w-16 md:w-44">
            <button
              mat-button
              color="primary"
              (click)="openEditDialog(element)"
              class="rounded-xl py-1 px-4 text-base font-bold"
            >
              <mat-icon color="primary" class="material-icons-outlined"
                >edit</mat-icon
              >
              <span class="hidden md:inline-block">Módosítás</span>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <!-- Empty State (Search) -->
      <div
        *ngIf="dataSource.data.length === 0"
        class="flex h-96 flex-col items-center justify-center"
      >
        <img
          alt="No results"
          src="../../../assets/figures/man-questioning.svg"
          class="mb-2 h-[88px]"
        />
        <p class="text-lg font-bold">Nincs találat</p>
        <p class="text-sm">
          {{
            searchTerm
              ? "Próbálj meg más keresési kifejezést."
              : "Nincs elérhető copy elem."
          }}
        </p>
      </div>
    </div>
  </mat-card>

  <!-- Pagination -->
  <mat-paginator
    *ngIf="dataLength > 0"
    [length]="dataLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="pageIndex"
    (page)="onPagination($event)"
    class="mt-6 rounded-2xl"
  >
  </mat-paginator>
</div>
